export class StaticConstants {
  static readonly AppPreference = {
    QuickOrderRowCount: 'QUICK_ORDER_ROW_COUNT',
    DefaultMinOrderValue: 'ORDER_MIN_BASE',
    C2MinOrderValue: 'ORDER_MIN_CLASS2BASE',
    HawaiiMinOrderValue: 'ORDER_MIN_HIAK',
    AlaskaMinOrderValue: 'ORDER_MIN_HIAK',
    MixOrderMinValue: 'ORDER_MIN_MIXBASE',
    AccountNonC2ByPassValue: 'ORDER_MIN_BYPASS',
    XIINTERCEPT_URL: 'XIINTERCEPT_URL',
    MERCHANT_GUID: 'MERCHANT_GUID',
    SUPPLIER_NAME_BEFORE: 'SUPPLIER_NAME_BEFORE',
    SUPPLIER_REG_NUM_BEFORE: 'SUPPLIER_REG_NUM_BEFORE',
    SUPPLIER_ADDR_BEFORE: 'SUPPLIER_ADDR_BEFORE',
    SUPPLIER_NAME_AFTER: 'SUPPLIER_NAME_AFTER',
    SUPPLIER_REG_NUM_AFTER: 'SUPPLIER_REG_NUM_AFTER',
    SUPPLIER_ADDR_AFTER: 'SUPPLIER_ADDR_AFTER',
    SUPPLIER_DATA_ORDER_DATE: 'SUPPLIER_DATA_ORDER_DATE',
  };

  static readonly MasterEntityKey = {
    WorkingHours: 'HOURS_OF_OPERATION',
    BUSINESS_MANAGED_ALERT: 'BUSINESS_MANAGED_ALERT',   
    AUTHENTICATED_BUSINESS_MANAGED_ALERT: 'AUTHENTICATED_BUSINESS_MANAGED_ALERT',
    ProductHazardousCodes: 'PRODUCT_HAZARDOUS_CODES',
    ProductNonRefrigeratedCodes: 'PRODUCT_NON_REFRIGERATED_CODES', 
  }

  static readonly TypeGroup = {
    ContactUsReason: 1,
    ContactUsPreferredMethod: 8,
    ProductSearchOptions: 5,
    AdvanceSearchOptions: 6,
    AdvanceSearchOperand: 7,
    State: 16,
    SubscriptionFrequency: 55
  };

  static readonly TypeRef = {
    BasicSearch: 200,
    AdvanceSearch: 201,
    AdvanceSearchBasicOption: 256,
    Logout: 851,
    Timeout: 853
  };
}
